import { FieldValues, UseFormRegister } from "react-hook-form";
import { InputHTMLAttributes } from "react";
import { cva, VariantProps } from "class-variance-authority";

interface InputProps
  extends
    VariantProps<typeof inputClasses>,
    InputHTMLAttributes<HTMLInputElement> {
  register?: UseFormRegister<FieldValues>;
}

const inputClasses = cva("text-md py-2 px-3 block rounded-md", {
  variants: {
    variant: {
      normal: "border-2 border-black",
      error: "border-2 border-red-600 outline-red-600 bg-red-100",
    },
    inputSize: {
      small: "w-60",
      medium: "w-[18rem]",
      large: "w-100",
      "x-large": "w-140",
    },
  },
  defaultVariants: {
    variant: "normal",
    inputSize: "medium",
  },
});

export default function Input({
  register,
  variant,
  inputSize,
  ...props
}: InputProps) {
  const classes = inputClasses({
    variant,
    inputSize,
    className: props.className,
  });

  return (
    <input
      {...(register && register(props.name!))}
      {...props}
      className={classes}
    />
  );
}
